import React from "react";
import * as XLSX from "xlsx";
import download_icon from "../../Icons/download_icon.png";

const super_admin = localStorage.getItem("super_admin");
const isSuperAdmin = super_admin === "true" || super_admin === true;
const ExcelExport = ({ convertedleadResponse }) => {
  const exportToExcel = () => {
    // Check if leadResponse is not undefined or empty
    if (!convertedleadResponse || convertedleadResponse.length === 0) {
      return;
    }

    const headers = [
      "Last Modified On",
      "Lead ID",
      "Estimate Id",
      "Lead Entry Date",
      "Booking Date",
      "Execution Date",
      "Execution TAT",
      "AQCS NOC DATE",
      "Status",
      "Lead Type",
      "Lead Source",
      "Lead Owner",
      "Coordinator",
      "Field Ops",
      "Ops Email ID",
      "Ops Contact Number",
      "Customer Name",
      "Shipper Name",
      "Contact Number",
      "Email",
      "Pet Type",
      "Breed",
      "Age ( In Months)",
      "Pet Dimn.",
      "Cage Size",
      "Pet Name",
      "Pet DOB",
      "No. of Pets",
      "Pet Behaviour",
      "Titre Test Status",
      "Scope of Work",
      "Region",
      "Origin Country",
      "Origin State",
      "Origin City",
      "Origin Airport",
      "Destination Country",
      "Destination State",
      "Destination City",
      "Destination Airport",
      "Service Type",
      "Overseas Vendor",
      "Pet Boarding Vendor",
      "Mode",
      "Qty",
      "Cage Required",
      "Cage Status",
      "Cage Trained",
      "Amount In AED",
      "Quotation",
      "Payment Ter",
      "Token Payment",
      "Remaining Payment",
      "Pymt Status",
      "Payment Mode",
      "Booking Status",
      "Shipment Reference No.",
      "Add Proof",
      "Remarks",
      "Review Link",
      "File Submit in Accounts",
      "Amount Excluding GST",
      "GST",
      "Alternate Contact No.",
      "Airline Name",
      "Baggage Type",
    ];

    const data = convertedleadResponse.map((item, index) => ({
      "Last Modified On": item.modifiedDate,
      "Lead ID": item.Relocation_ID,
      "Estimate Id": item.Estimate_Id,
      "Lead Entry Date": item.lead_entry_date,
      "Booking Date": `${item.day_of_conversion} ${item.Booking_Date}`,
      "Execution Date": `${item.day_of_week} ${item.Execution_Date}`,
      "Execution TAT": item.Execution_TAT,
      "AQCS NOC DATE": item.AQCS_NOC_DATE,
      "Status": item.order_status,
      "Lead Source": item.leadSource,
      "Lead Owner": item.Lead_Owner,
      "Coordinator": item.Coordinator,
      "Field Ops": item.Field_Ops,
      "Ops Email ID": item.ops_emailId,
      "Ops Contact Number": item.ops_contactNumber,
      "Customer Name": item.Customer_Name,
      "Shipper Name": item.Shipper_Name,
      "Contact Number": item.Contact_Number,
      "Email": item.Email,
      "Pet Type": item.pet_type,
      "Breed": item.Breed,
      "Age ( In Months)": item.Age_In_Months,
      "Pet Dimn.": item.Pet_Dimn,
      "Cage Size": item.Cage_Size,
      "Pet Name": item.Pet_Name,
      "Pet DOB": item.Pet_DOB,
      "No. of Pets": item.Number_of_Pets,
      "Pet Behaviour": item.Pet_Behaviour,
      "Titre Test Status": item.Titre_Test_Status,
      "Scope of Work": item.Job_Type,
      "Region": item.region_name,
      "Service Type": item.Service_Type,
      "Overseas Vendor": item.Overseas_Vendor,
      "Pet Boarding Vendor": item.Pet_Boarding_Vendor,
      "Mode": item.Mode,
      "Qty": item.Qty,
      "Cage Required": item.Cage_Required,
      "Cage Status": item.Cage_Status,
      "Cage Trained": item.Cage_Trained,
      "Amount In AED": item.Amount_In_AED,
      "Quotation": item.Quotation,
      "Payment Ter": item.Payment_Ter,
      "Token Payment": item.Token_Payment,
      "Remaining Payment": item.Remaining_Payment,
      "Pymt Status": item.Pymt_Status,
      "Payment Mode": item.Payment_Mode,
      "Booking Status": item.Booking_Status,
      "Shipment Reference No.": item.Shipment_Reference_No,
      "Add Proof": item.Add_Proof,
      "Remarks": item.Remarks,
      "Review Link": item.Review_Link,
      "File Submit in Accounts": item.File_Submit_in_Accounts,
      "Amount Excluding GST": item.amount_exc_gst,
      "GST": item.GST,

      "Lead Type": item.lead_region,
      "Origin Country": item.origin_country,
      "Origin State": item.origin_state,
      "Origin City": item.origin_city,
      "Origin Airport": item.Origin_Airport,
      "Destination Country": item.destination_country,
      "Destination State": item.destination_state,
      "Destination City": item.destination_city,
      "Destination Airport": item.Arrival_Airport,
      "Alternate Contact No.": item.alternate_number,
      "Airline Name": item.airline_name,
      "Baggage Type": item.baggage_type,
    }));

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data, { header: headers });

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

    // Generate today's date in YYYYMMDD format
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10).replace(/-/g, "");

    // Save the Excel file with the new name
    const fileName = `ConvertedLeadDataReport_${formattedDate}.xlsx`;
    XLSX.writeFile(workbook, fileName, { type: "array" });
  };

  return isSuperAdmin ? (
    <button
      onClick={exportToExcel}
      style={{
        height: "47px",
        border: "1px solid #C0C6CC",
        borderRadius: "7.5px",
        color: "#6A6A6A",
      }}
    >
      <img src={download_icon} alt="download" /> Download Excel
    </button>
  ) : null;
};

export default ExcelExport;
